<template>
    <div>
        <CommonComponentsProductsTitleFunctionTitle
            :function-title="data.functionTitle"
            :color-index="data.functionTitleColorIndex"
            class="product-fabric-part-2-function-title"
        />
        <div
            v-for="(contentItem, contentIndex) in data.part2Data"
            :key="contentIndex"
            class="product-fabric-part-2-grid"
        >
            <div
                v-for="(textItem, textIndex) in contentItem.textItem"
                :key="textIndex"
                class="product-fabric-part-2-text-item-container"
            >
                <CommonComponentsProductsTitleFunctionTitle
                    :function-title="textItem.functionTitle"
                    :color-index="data.functionTitleColorIndex"
                    :class="`product-fabric-part-2-text-function-title-${contentIndex}`"
                />
                <div class="product-fabric-part-2-text-content">
                    <div
                        v-for="(p2text, textIndex) in textItem.texts"
                        :key="textIndex"
                        class="product-fabric-content-text"
                        :class="`product-fabric-content-text-${contentIndex}`"
                    >
                        <CommonComponentsTextWithCheckIcon>
                            <span class="fabric-text-scroll">
                                {{ $t(p2text) }}
                            </span>
                        </CommonComponentsTextWithCheckIcon>
                    </div>
                </div>
            </div>
            <div class="product-fabric-part-2-img">
                <img
                    :class="`fabric-fade-in product-fabric-part-2-img-${contentIndex}`"
                    class="lazy"
                    :data-src="`${contentItem.imgPath}`"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import p2img1CnMobile from '@assets/imgs/Products/Fabric/p2img1CnMobile.png';
    import p2img1CnPc from '@assets/imgs/Products/Fabric/p2img1CnPc.png';
    import p2img1EnMobile from '@assets/imgs/Products/Fabric/p2img1EnMobile.png';
    import p2img1EnPc from '@assets/imgs/Products/Fabric/p2img1EnPc.png';
    import p2img2 from '@assets/imgs/Products/Fabric/p2img2.png';
    import { computed } from 'vue';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const isCN = ifCNLocale();
    const isMobile = ref(false);

    const p2img1Url = computed(() => {
        if (isCN) {
            switch (isMobile.value) {
                case true:
                    return p2img1CnMobile;
                default:
                    return p2img1CnPc;
            }
        } else {
            switch (isMobile.value) {
                case true:
                    return p2img1EnMobile;
                default:
                    return p2img1EnPc;
            }
        }
    });

    const data = reactive({
        functionTitle: {
            colorTitle: 'global_fabric_colorTitle3',
            title: 'global_fabric_title_1',
            // subTitle: 'global_fabric_subtitle_2',
        },
        functionTitleColorIndex: 1,
        part2Data: [
            {
                imgPath: p2img1Url,
                // imgTitle: 'global_fabric_content_img_title_0',
                textItem: [
                    {
                        title: 'global_fabric_content_text_10',
                        subTitle: 'global_fabric_content_subText_10',
                        functionTitle: {
                            colorTitle: 'global_fabric_colorTitle1',
                            title: 'global_fabric_content_img_title_0',
                        },
                        texts: [
                            'global_fabric_content_text_10',
                            'global_fabric_content_text_11',
                            'global_fabric_content_text_12',
                        ],
                    },
                ],
            },
            {
                imgPath: p2img2,
                // imgTitle: 'global_fabric_content_img_title_1',
                textItem: [
                    {
                        title: 'global_fabric_content_text_13',
                        subTitle: isMobile.value
                            ? 'global_fabric_content_subText_13_mobile'
                            : 'global_fabric_content_subText_13',
                        functionTitle: {
                            colorTitle: 'global_fabric_colorTitle2',
                            title: isMobile.value
                                ? 'global_fabric_content_img_title_1'
                                : 'global_fabric_content_img_title_1_mobile',
                        },
                        texts: [
                            'global_fabric_content_text_13',
                            'global_fabric_content_text_14',
                            'global_fabric_content_text_15',
                        ],
                    },
                ],
            },
        ],
    });

    onMounted(() => {
        isMobile.value = matchMobile();
    });
</script>

<style lang="less" scoped>
    .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .product-fabric-part-2-function-title {
        margin-bottom: .convert(20px) [ @vw];
    }

    .product-fabric-part-2-grid {
        display: grid;
        // grid-template-columns: 417fr 263fr; //723 642
        grid-template-columns: 603fr 602fr; //723 642
        grid-template-rows: 1fr;
        grid-auto-flow: dense; //填充
        position: relative;
        .product-fabric-part-2-img {
            .flex-center();
            flex-direction: column;
            gap: 30px;
            grid-column: 2; //反向
            &-0 {
                margin-right: .convert(-13px) [ @vw];
                margin-top: .convert(60px) [ @vw];
                height: .convert(400px) [ @vw];
            }

            &-1 {
                position: absolute;
                right: .convert(-37px) [ @vw];
                height: .convert(353px) [ @vw];
                margin-top: .convert(68px) [ @vw];
            }
        }

        .product-fabric-part-2-text-item-container {
            display: flex;
            flex-direction: column;
            gap: .convert(16px) [ @vw];
            white-space: nowrap;
            .product-fabric-part-2-text-function-title-0 {
                :deep(.function-colortitle) {
                    color: #fff;
                }
                :deep(.function-title) {
                    font-size: .convert(40px) [ @vw]; //40px
                    margin-bottom: .convert(72px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        font-size: .convert(20px) [ @vw-mobile]; //20px
                        margin-bottom: .convert(20px) [ @vw-mobile];
                    }
                }
            }
            .product-fabric-part-2-text-function-title-1 {
                :deep(.function-colortitle) {
                    color: #fff;
                }
                :deep(.function-title) {
                    font-size: .convert(40px) [ @vw]; //40px
                    margin-bottom: .convert(164px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        font-size: .convert(20px) [ @vw-mobile]; //20px
                        margin-bottom: .convert(20px) [ @vw-mobile];
                    }
                }
            }
            .product-fabric-part-2-text-content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: .convert(26px) [ @vw];
                font-family: 'HarmonyOS Sans SC';
                .product-fabric-content-text {
                    :deep(.check-icon) {
                        margin-right: .convert(8px) [ @vw];
                    }
                }
                .product-fabric-content-text-0 {
                    @media (max-width: @screen-mobile-width) {
                        width: .convert(310px) [ @vw-mobile];
                    }
                }
                .product-fabric-content-text-1 {
                    @media (max-width: @screen-mobile-width) {
                        width: .convert(312px) [ @vw-mobile];
                    }
                }
            }
        }
        &:nth-child(2) {
            .product-fabric-part-2-text-item-container {
                padding-top: .convert(80px) [ @vw];
            }
        }

        &:nth-child(n + 3) {
            margin-top: .convert(150px) [ @vw];
        }

        @media (max-width: @screen-mobile-width) {
            .product-fabric-part-2-img {
                &-0 {
                    height: .convert(201px) [ @vw-mobile];
                }

                &-1 {
                    position: unset;
                    height: .convert(211px) [ @vw-mobile];
                }
            }
            .product-fabric-part-2-text-item-container {
                .svg-check-icon {
                    width: .convert(7px) [ @vw-mobile];
                    height: .convert(14px) [ @vw-mobile];
                }
            }

            // 布局调整

            &:not(:last-child) {
                margin-bottom: 30px;
            }

            &:nth-child(n + 2) {
                display: flex;
                flex-direction: column;
                gap: 10px;
                .product-fabric-part-2-img {
                    gap: 0;
                    &-0 {
                        height: .convert(444px) [ @vw-mobile];
                    }

                    &-1 {
                        margin-top: .convert(20px) [ @vw-mobile];
                        height: .convert(150px) [ @vw-mobile];
                    }
                }
                .product-fabric-part-2-text-content {
                    gap: .convert(15px) [ @vw-mobile];
                }
            }

            &:nth-child(2) {
                margin-top: .convert(40px) [ @vw-mobile];
            }
        }
    }

    :lang(en) {
        .product-fabric-content-text-0 {
            width: .convert(550px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                width: .convert(317px) [ @vw-mobile] !important;
            }
        }
        .product-fabric-content-text-1 {
            width: .convert(491px) [ @vw];
        }
    }
</style>
